import { isNil } from 'lodash-es';
import { Resource } from '../Resource';
const rootPath = 'reverse-geocoding';
export const fromRaw = (raw) => ({
    locationAsText: raw.location_text
});
const reverseGeocoding = Resource((requesterBuilder, config) => {
    return {
        get: (query) => requesterBuilder({
            path: rootPath,
            requestCtx: {
                params: {
                    query: {
                        latitude: !isNil(query?.latitude)
                            ? query?.latitude.toString().slice(0, 19)
                            : undefined,
                        longitude: !isNil(query?.longitude)
                            ? query?.longitude.toString().slice(0, 19)
                            : undefined
                    }
                },
                host: config.getCtx().hosts.tiles,
                transform: fromRaw
            }
        })
    };
});
export default reverseGeocoding;
